var $ = require('jquery');

$(function () {
    $(".insight-asset-detail .article-header__download").each(function () {
        const $this = $(this);
        const downloadUrl = $this.find('a').attr('href');
        const downloadTarget = $this.find('a').attr('target') || '';
        if (downloadUrl) {
            const downloadImage = $this.parent().find('.article-header__image img');
            downloadImage.wrap('<a href="' + downloadUrl + '" target="' + downloadTarget + '"></a>');
        }
    });
}); 
